import { createRouter, createWebHistory } from 'vue-router'
import { save } from './shared/storage'

const routes = [
  {
    path: '/',
    name: 'Root',
    redirect: { name: 'Home' },
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ './app/home/HomeScreen'),
  },
  {
    path: '/connect',
    name: 'Connect',
    component: () => import(/* webpackChunkName: "connect" */ './app/connect/ConnectScreen'),
  },
  {
    path: '/setup',
    name: 'Setup',
    component: () => import(/* webpackChunkName: "setup" */ './app/setup/SetupScreen'),
  },
  {
    path: '/execute',
    name: 'Execute',
    component: () => import(/* webpackChunkName: "execute" */ './app/execute/ExecuteScreen'),
  },
  {
    path: '/execute/:code',
    name: 'ExecuteTestCase',
    component: () => import(/* webpackChunkName: "execute" */ './app/execute/ExecuteTestCaseScreen'),
    props: ({ params: { code } }) => ({ code }),
  },
  {
    path: '/results',
    name: 'Results',
    component: () => import(/* webpackChunkName: "results" */ './app/results/ResultsScreen'),
  },
  {
    path: '/share',
    name: 'Share',
    component: () => import(/* webpackChunkName: "share" */ './app/share/ShareScreen'),
  },
  {
    path: '/shared-results/:encoded',
    name: 'SharedResults',
    component: () => import(/* webpackChunkName: "sharedResults" */ './app/shared-results/SharedResultsScreen'),
  },
  {
    path: '/oauth/callback/:provider',
    name: 'OAuthCallback',
    component: () => import(/* webpackChunkName: "sharedResults" */ './oauth/OAuthCallbackScreen'),
    props: ({ params: { provider } }) => ({ provider }),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: () => ({ name: 'Home' }),
  },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  linkActiveClass: 'active',
})

router.afterEach(save)

export default router
